import React, { useEffect, useState } from "react";
import { HeroProductsStatic } from '../../components';
import { Banner, BannerTech } from '../../components';
import { Loader } from '../../components';
import { NumbersWrap } from '../../components';
import { NumbersRowSingle } from '../../components';
import { NumberCell } from '../../components';
import { VideoScrollAlone } from '../../components';
import { GalleryProds } from '../../components';
import { useSelector } from "react-redux";
import { BaseUrl } from "../../config";


const ProductsStoreInStoreContainer = (props) => {
  const loader = useSelector((state) => state.loader);

  const [imgsGallery, setImgsGallery] = useState([])

  const imgHero = require('../../assets/hero-solutions/hero-store-in-store.jpg');

  const arrayLoad = [
    imgHero
  ]

  useEffect(() => {
    document.title = "Store In-Store by Invrsion"
   
    fetch(`${BaseUrl}/page?key=invrsion&slug=store-in-store`, {
      method: 'GET'
    })
    .then(response => {
      return response.json()
      
    }).then((res) => {
      setImgsGallery(res.data.sliderSketchfab);
    })
    
   
    
  }, []);
  
  return (
    <React.Fragment>
      <HeroProductsStatic 
        title="Open up your store to new possibilities with<br>Store In-Store..." 
        img={imgHero}
        subtitle="...by ensuring you have your entire product catalogue always on hand and bringing it all to life with a fully interactive, immersive, and ready to go VR experience."
      >

      </HeroProductsStatic>
  
      
      <div className="side--quote-wrap extra--margin">
        <h6 className="md--title side--title">What is Store In-Store?</h6>
        <p className="preset-9 side--text">Make the most of your current space by adding another dimension to your product catalog. Immersing your in-store clients in an out-of-store VR experience.</p>
      </div>
      <div className="side--quote-wrap">
        <h6 className="md--title side--title">Reality in realtime</h6>
        <p className="preset-9 side--text">Assist your clients in an all new way by adding a VR experience to your shopping experience. Allowing them to visualize and experience, compare, and evaluate in realtime every product you have in every color, style, and way they want.</p>
      </div>
      <div className="side--quote-wrap">
        <h6 className="md--title side--title">Feel the difference</h6>
        <p className="preset-9 side--text">We use advanced technology to give your objects the truest-to-life look and feel. The final result is an interactive and fully customizable and immersive experience, ready to be shared in your store via headset or mobile devices.</p>
      </div>
      <NumbersWrap>
        <NumbersRowSingle
          extraMargin={true}
        >
          <NumberCell 
            isImage={false} 
            bigNumber="184" 
            size="B" 
            title="Dollar boost" 
            text="to global GDP from the use of VR and AR in the retail and consumer sector by 2030 (PwC)"
          />
          <NumberCell 
            isImage={false} 
            bigNumber="93" 
            size="%" 
            title="Of executives" 
            text="say they or their clients plan to increase their investment in VR and AR in the wake of COVID-19 (IDC)"
          />
        </NumbersRowSingle>
      </NumbersWrap>

      {
        imgsGallery.length > 0 &&
        <GalleryProds imgs={imgsGallery}/>
      }
      {
        !loader.isLoading &&
        <VideoScrollAlone
          idScroll="video-storeinstore"
          video={require('../../assets/video/video-real-estate-3.mp4')} 
        />

      }
      <Banner  text="Intrigued? Let’s have a chat." route="/book-a-demo" copyRoute="Book a demo" />
      <Loader arrayLoad={arrayLoad}/>
    </React.Fragment>
  );
};

export default ProductsStoreInStoreContainer;
